/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { useMutation } from "@apollo/client";
import { useTour } from "src/context/global/TourContext";
import DISCONNECT_PAGE from "src/graphql/mutation/settings/disconnectPage";
import CONNECT_PAGE from "src/graphql/mutation/settings/connectPage";
import DELETE_PAGE from "src/graphql/mutation/settings/deletePage";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddTaskIcon from "@mui/icons-material/AddTask";
import DialogBoxLayout from "src/components/shared/atoms/dialog";
// import InternalRow from "../../facebook/lowerComponent/row";
import clsx from "clsx";
import InternalRow from "./internalRow";
import UpgradeModal from "../../upgradeModal";
import useStyle from "./Styles";

interface Props {
  pagesData: any;
  setPagesData: (value: any) => void;
}

const InstagramInternalPage: React.FC<Props> = ({
  pagesData,
  setPagesData,
}) => {
  const { classes } = useStyle();
  const {
    postFbConnectionTourRun,
    startPostFbConnectionTour,
    stopPostFbConnectionTour,
    setPostFbConnectionStepIndex,
  } = useTour();

  const [groupedPages, setGroupedPages] = useState<{
    [key: string]: { waba_name: string; pages: any[] };
  }>({});

  useEffect(() => {
    if (pagesData && pagesData.length) {
      const grouped = pagesData.reduce((acc: any, curr: any) => {
        const key = curr.waba_id || "no-waba";
        if (!acc[key]) {
          acc[key] = {
            waba_name: curr.waba_name,
            pages: [],
          };
        }
        acc[key].pages.push(curr);
        return acc;
      }, {});
      setGroupedPages(grouped);
    }
  }, [pagesData]);

  const { enqueueSnackbar } = useSnackbar();
  const [removeModal, setRemoveModal] = useState(false);
  const closeDeleteDialog = () => setRemoveModal(false);
  const [disconnectModal, setDisconnectModal] = useState(false);
  const [connectModal, setConnectModal] = useState(false);
  const closeRemoveDialog = () => setDisconnectModal(false);
  const [wasTourRunning, setWasTourRunning] = useState(false);

  const closeConnectDialog = () => {
    setConnectModal(false);
    // Resume tour
    if (wasTourRunning) {
      startPostFbConnectionTour();
      setWasTourRunning(false);
    }
  };
  const [actionPageData, setActionPageData] = useState();
  const [
    disconnectPage,
    {
      loading: disConnectPageMutationLoading,
      error: disConnectPageMutationError,
      data: disConnectPageMutationResult,
    },
  ] = useMutation(DISCONNECT_PAGE);

  useEffect(() => {
    if (
      disConnectPageMutationResult &&
      disConnectPageMutationResult.disconnectPage
    ) {
      if (disConnectPageMutationResult.disconnectPage.success) {
        const updatedPagesData =
          pagesData && pagesData.length
            ? pagesData.map((element: { pageId: undefined }) => {
                if (element.pageId === actionPageData)
                  return {
                    ...element,
                    isSelected: false,
                  };
                return element;
              })
            : [];

        setPagesData(updatedPagesData);

        enqueueSnackbar(
          JSON.parse(disConnectPageMutationResult.disconnectPage.result),
          {
            variant: "info",
          },
        );
      } else {
        enqueueSnackbar(
          JSON.parse(disConnectPageMutationResult.disconnectPage.error),
          {
            variant: "error",
          },
        );
      }

      closeRemoveDialog();
    }
  }, [disConnectPageMutationResult]);

  useEffect(() => {
    if (disConnectPageMutationError) {
      disConnectPageMutationError.graphQLErrors?.map(({ message }) => {
        enqueueSnackbar(message, { variant: "error" });
      });
    }
  }, [disConnectPageMutationError]);

  const [
    connectPage,
    {
      loading: connectPageMutationLoading,
      error: connectPageMutationError,
      data: connectPageMutationResult,
    },
  ] = useMutation(CONNECT_PAGE);

  useEffect(() => {
    if (connectPageMutationResult && connectPageMutationResult.connectPage) {
      if (connectPageMutationResult.connectPage.success) {
        const updatedPagesData =
          pagesData && pagesData.length
            ? pagesData.map((element: { pageId: undefined }) => {
                if (element.pageId === actionPageData) {
                  return {
                    ...element,
                    isSelected: true,
                  };
                }
                return element;
              })
            : [];
        setPagesData(updatedPagesData);

        enqueueSnackbar(
          JSON.parse(connectPageMutationResult.connectPage.result),
          {
            variant: "info",
          },
        );

        // Advance onboarding tour to step 2 if it was running
        if (wasTourRunning) {
          setTimeout(() => {
            setPostFbConnectionStepIndex(1);
          }, 500);
        }
      } else {
        enqueueSnackbar(
          JSON.parse(connectPageMutationResult.connectPage.error),
          {
            variant: "error",
          },
        );
      }
      closeConnectDialog();
    }
  }, [connectPageMutationResult]);

  useEffect(() => {
    if (connectPageMutationError) {
      connectPageMutationError.graphQLErrors?.map(({ message }) => {
        enqueueSnackbar(message, { variant: "error" });
      });
    }
  }, [connectPageMutationError]);

  const [
    deletepage,
    {
      error: deletepageMutationError,
      data: deletepageMutationResult,
      loading: deletepageMutationLoading,
    },
  ] = useMutation(DELETE_PAGE);

  useEffect(() => {
    if (deletepageMutationResult && deletepageMutationResult.deletepage) {
      const pagesDataWithoutCurrData: any =
        pagesData &&
        pagesData.length &&
        pagesData.filter((curr: any) => curr.pageId !== actionPageData);
      setPagesData(pagesDataWithoutCurrData);
      enqueueSnackbar("page has been removed", { variant: "success" });
      //
      closeDeleteDialog();
    }
  }, [deletepageMutationResult]);

  useEffect(() => {
    if (deletepageMutationError) {
      deletepageMutationError.graphQLErrors?.map(({ message }) => {
        enqueueSnackbar(message, { variant: "error" });
      });
    }
  }, [deletepageMutationError]);

  const disConnectApiCallHandler = async () => {
    try {
      await disconnectPage({
        variables: {
          pageId: actionPageData,
        },
      });
    } catch (err: any) {
      enqueueSnackbar("Something went wrong. Try again", {
        variant: "error",
      });
    }
  };
  const removeApiCallHandler = async () => {
    try {
      await deletepage({
        variables: {
          pageId: actionPageData,
        },
      });
    } catch (err: any) {
      enqueueSnackbar("Something went wrong. Try again", {
        variant: "error",
      });
    }
  };
  const connectApiCallHandler = async () => {
    try {
      await connectPage({
        variables: {
          pageId: actionPageData,
        },
      });
    } catch (err: any) {
      enqueueSnackbar("Something went wrong. Try again", {
        variant: "error",
      });
    }
  };

  const disconnectedHandler = (data: any) => {
    setDisconnectModal(true);
    setActionPageData(data.pageId);
  };

  const closeHandler = (data: any) => {
    setRemoveModal(true);
    setActionPageData(data.pageId);
  };

  const connectedHandler = (data: any) => {
    setConnectModal(true);
    setActionPageData(data.pageId);
    // Pause tour
    if (postFbConnectionTourRun) {
      setWasTourRunning(true);
      stopPostFbConnectionTour();
    }
  };

  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);

  const showUpgradePopUp = () => {
    setOpenUpgradeModal(true);
  };

  return (
    <Box
    // sx={{
    //   height: "calc(100vh - 350px)",
    //   overflowY: "auto",
    // }}
    >
      <UpgradeModal open={openUpgradeModal} setOpen={setOpenUpgradeModal} />
      <CardContent className={classes.cardContent}>
        <Box>
          <Table className={classes.tableStyle}>
            <TableBody>
              {/* {pagesData.map((curr: any) => {
                return (
                  <InternalRow
                    loading={
                      (connectPageMutationLoading ||
                        disConnectPageMutationLoading) &&
                      actionPageData === curr.pageId
                    }
                    disabled={
                      (connectPageMutationLoading ||
                        disConnectPageMutationLoading) &&
                      actionPageData === curr.pageId
                    }
                    connectedHandler={connectedHandler}
                    disconnectedHandler={disconnectedHandler}
                    showUpgradePopUp={showUpgradePopUp}
                    curr={curr}
                    closeHandler={closeHandler}
                  />
                );
              })} */}
              {Object.entries(groupedPages).map(
                ([waba_id, group], groupIndex) => (
                  <React.Fragment key={waba_id}>
                    <TableRow>
                      <TableCell className={clsx(classes.rowCell)}>
                        <Typography
                          component="strong"
                          sx={{ display: "inline-block" }}
                        >
                          {group.waba_name || "No WABA"}
                        </Typography>
                      </TableCell>
                    </TableRow>
                    {group.pages.map((curr: any, pageIndex: number) => (
                      <InternalRow
                        key={curr.pageId}
                        id={
                          groupIndex === 0 && pageIndex === 0
                            ? "tour-connect-page-button"
                            : undefined
                        }
                        loading={
                          (connectPageMutationLoading ||
                            disConnectPageMutationLoading) &&
                          actionPageData === curr.pageId
                        }
                        disabled={
                          (connectPageMutationLoading ||
                            disConnectPageMutationLoading) &&
                          actionPageData === curr.pageId
                        }
                        connectedHandler={connectedHandler}
                        disconnectedHandler={disconnectedHandler}
                        showUpgradePopUp={showUpgradePopUp}
                        curr={curr}
                        closeHandler={closeHandler}
                      />
                    ))}
                  </React.Fragment>
                ),
              )}
            </TableBody>
          </Table>
        </Box>
      </CardContent>
      {removeModal && (
        <DialogBoxLayout
          btnText="Remove"
          icon={<DeleteForeverIcon color="success" />}
          open={removeModal}
          actionHandler={removeApiCallHandler}
          text="Do you really want to remove this page?"
          modalClose={closeDeleteDialog}
          loader={deletepageMutationLoading}
        />
      )}

      {disconnectModal && (
        <DialogBoxLayout
          btnText="Disconnect"
          icon={<CancelIcon color="success" />}
          open={disconnectModal}
          actionHandler={disConnectApiCallHandler}
          text="Do you really want to disconnect this page?"
          modalClose={closeRemoveDialog}
          loader={disConnectPageMutationLoading}
        />
      )}
      {connectModal && (
        <DialogBoxLayout
          btnText="Connect Page"
          icon={<AddTaskIcon color="success" />}
          open={connectModal}
          actionHandler={connectApiCallHandler}
          text="Do you want to connect this page?"
          modalClose={closeConnectDialog}
          loader={connectPageMutationLoading}
        />
      )}
    </Box>
  );
};

export default InstagramInternalPage;
